import * as React from 'react';
import styled from 'styled-components';

import { AquaMenuItem } from './AquaMenuItem';
import { AquaTheme as T } from '../AquaTheme';
import { IDatagroup } from '../../../types/IDatagroup';
import { IDataset } from '../../../types/IDataset';

interface IProps {
  /** @ignore */
  className?: string;
  /** Group to show. */
  group: IDatagroup;
  /** Datasets in the group. */
  datasets: IDataset[];
  /** Fired when a Dataset in the group is clicked. */
  onClick: (datasetKey: string) => void;
}

const AquaMenuGroupBase = (props: IProps) => {
  return (
    <div className={props.className} role="group" aria-label={props.group.title}>
      <Header>
        <Title>{props.group.title}</Title>
        <Description>{props.group.description}</Description>
      </Header>
      <Content>
        {props.datasets.sort((a,b) => a.title > b.title ? 1 : -1).map(dataset =>
          <AquaMenuItem key={dataset.key} data={dataset} exclusive={props.group.exclusive} onClick={() => props.onClick(dataset.key)}/>)}
      </Content>
    </div>
  )
}

const Title = styled.div`
  font: ${T.font.labelCaps};
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${T.colors.primary[1]};
`

const Description = styled.div`
  font: ${T.font.bodySmall};
  color: ${T.colors.neutral[80]};
  margin-top: 2px;
`

const Header = styled.div`
  padding: 16px 4px 10px 4px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

const AquaMenuGroup = styled(AquaMenuGroupBase)`
`

export { AquaMenuGroup }
